import * as React from 'react';
import { AppLanguage, AppRoute } from '~/common/enums/enums';
import { BlogPostContext, SeoPayload } from '~/common/types/types';
import { Layout, Link } from '~/components/common/common';
import { headerPayload, footerPayload } from '~/common/payload/payload';
import { Post } from './components/components';
import * as styles from './post-page.module.scss';

type Props = {
  pageContext: BlogPostContext;
};

const PostPage: React.FC<Props> = ({ pageContext }) => {
  const { post, originalLink, currentLanguage } = pageContext;
  const { title, seoDescription } = post.info;

  const seoPayload: SeoPayload = {
    language: AppLanguage.UA,
    title,
    description: seoDescription,
  };

  return (
    <Layout
      headerPayload={headerPayload}
      footerPayload={footerPayload}
      seoPayload={seoPayload}
    >
      <div className={styles.page}>
        <Link localLink={AppRoute.ROOT} className={styles.backLink}>
          ← Academy Blog
        </Link>
        <Post
          originalLink={originalLink}
          currentLanguage={currentLanguage}
          post={post}
        />
      </div>
    </Layout>
  );
};

export { PostPage };
